import { render, staticRenderFns } from "./Forms.vue?vue&type=template&id=427740dd&scoped=true&"
import script from "./Forms.vue?vue&type=script&lang=js&"
export * from "./Forms.vue?vue&type=script&lang=js&"
import style0 from "./Forms.vue?vue&type=style&index=0&id=427740dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427740dd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/tempos21/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('427740dd', component.options)
    } else {
      api.reload('427740dd', component.options)
    }
    module.hot.accept("./Forms.vue?vue&type=template&id=427740dd&scoped=true&", function () {
      api.rerender('427740dd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Pages/Styles/Forms.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/Styles/Forms.vue
// module id = Vgr0
// module chunks = 0